import React from 'react';
import { AvailabilityStatus } from '../types';
interface StatusToggleProps {
  status: AvailabilityStatus;
  onClick: () => void;
  disabled?: boolean;
}
const STATUS_STYLES: Record<AvailabilityStatus, {
  bg: string;
  shadow: string;
  label: string;
}> = {
  available: {
    bg: 'bg-green-500',
    shadow: 'shadow-green-500/40',
    label: 'Qualified and Available'
  },
  limited: {
    bg: 'bg-yellow-400',
    shadow: 'shadow-yellow-400/40',
    label: 'Qualified not Available'
  },
  unavailable: {
    bg: 'bg-red-500',
    shadow: 'shadow-red-500/40',
    label: 'Not Qualified'
  }
};
export function StatusToggle({
  status,
  onClick,
  disabled
}: StatusToggleProps) {
  const styles = STATUS_STYLES[status];
  return <button onClick={onClick} disabled={disabled} className={`
        h-5 w-5 rounded-full transition-all duration-200 ease-out focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-[#EB1000]
        ${styles.bg} ${styles.shadow}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:scale-110 shadow-md'}
      `} title={styles.label} aria-label={`Toggle status. Currently: ${styles.label}`} data-id="element-274">
      <span className="sr-only" data-id="element-275">{styles.label}</span>
    </button>;
}